import { render, staticRenderFns } from "./EstimateTaskBundleItem.vue?vue&type=template&id=a147b9f2&"
import script from "./EstimateTaskBundleItem.vue?vue&type=script&lang=js&"
export * from "./EstimateTaskBundleItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports